import { UserRoleEnum } from 'entities/index';
import {
  AboutPage,
  AdministratorPage,
  BusinessPage,
  BusinessRegistrationPage,
  BusinessSettingsPage,
  BusinessesPage,
  CreateAdministratorPage,
  CreateEmployeePage,
  CreateManagerPage,
  CreatePointPage,
  CustomerCreateBookingPage,
  EmployeePage,
  LicenseAgreementPage,
  ManagerPage,
  PointPage,
  PointSettingsPage,
  PointEmployeeSchedulesPage,
  ProfilePage,
  SignInPage,
  SignUpPage,
  DayCalendarPage,
  EmailConfirmationPage,
  PasswordChangePage,
  PrivacyPolicyPage,
  TermsOfServicePage,
  CookiePolicyPage,
} from 'pages';
import { createBrowserRouter } from 'react-router-dom';
import { AppLinks } from './consts/app-links.enum';
import RoleGuard from './guards/role-guard';

export const AppRouter = createBrowserRouter([
  {
    path: AppLinks.AboutLink,
    element: <AboutPage />,
  },
  {
    path: AppLinks.SignInLink,
    element: <SignInPage />,
  },
  {
    path: AppLinks.SignUpLink,
    element: <SignUpPage />,
  },
  {
    path: AppLinks.BusinessesLink,
    element: (
      <RoleGuard
        Component={BusinessesPage}
        acceptedRoles={[UserRoleEnum.OWNER]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.BusinessRegistrationLink,
    element: (
      <RoleGuard
        Component={BusinessRegistrationPage}
        acceptedRoles={[UserRoleEnum.OWNER]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.OwnerProfileLink,
    element: (
      <RoleGuard
        Component={ProfilePage}
        acceptedRoles={[
          UserRoleEnum.OWNER,
          UserRoleEnum.MANAGER,
          UserRoleEnum.EMPLOYEE,
          UserRoleEnum.ADMINISTRATOR,
        ]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.BusinessLink,
    element: (
      <RoleGuard
        Component={BusinessPage}
        acceptedRoles={[
          UserRoleEnum.OWNER,
          UserRoleEnum.ADMINISTRATOR,
          UserRoleEnum.MANAGER,
          UserRoleEnum.EMPLOYEE,
        ]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.CreatePointLink,
    element: (
      <RoleGuard
        Component={CreatePointPage}
        acceptedRoles={[UserRoleEnum.OWNER, UserRoleEnum.ADMINISTRATOR]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.CreateManagerLink,
    element: (
      <RoleGuard
        Component={CreateManagerPage}
        acceptedRoles={[UserRoleEnum.OWNER, UserRoleEnum.ADMINISTRATOR]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.CreateAdministratorLink,
    element: (
      <RoleGuard
        Component={CreateAdministratorPage}
        acceptedRoles={[UserRoleEnum.OWNER, UserRoleEnum.ADMINISTRATOR]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.BusinessSettingsLink,
    element: (
      <RoleGuard
        Component={BusinessSettingsPage}
        acceptedRoles={[UserRoleEnum.OWNER]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.PointLink,
    element: (
      <RoleGuard
        Component={PointPage}
        acceptedRoles={[
          UserRoleEnum.OWNER,
          UserRoleEnum.ADMINISTRATOR,
          UserRoleEnum.MANAGER,
          UserRoleEnum.EMPLOYEE,
        ]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.AdministratorLink,
    element: (
      <RoleGuard
        Component={AdministratorPage}
        acceptedRoles={[
          UserRoleEnum.OWNER,
          UserRoleEnum.ADMINISTRATOR,
          UserRoleEnum.MANAGER,
          UserRoleEnum.EMPLOYEE,
        ]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.ManagerLink,
    element: (
      <RoleGuard
        Component={ManagerPage}
        acceptedRoles={[
          UserRoleEnum.OWNER,
          UserRoleEnum.ADMINISTRATOR,
          UserRoleEnum.MANAGER,
          UserRoleEnum.EMPLOYEE,
        ]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.PointSettingsLink,
    element: (
      <RoleGuard
        Component={PointSettingsPage}
        acceptedRoles={[UserRoleEnum.OWNER, UserRoleEnum.ADMINISTRATOR]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.EmployeeLink,
    element: (
      <RoleGuard
        Component={EmployeePage}
        acceptedRoles={[
          UserRoleEnum.OWNER,
          UserRoleEnum.ADMINISTRATOR,
          UserRoleEnum.MANAGER,
          UserRoleEnum.EMPLOYEE,
        ]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.CreateEmployeeLink,
    element: (
      <RoleGuard
        Component={CreateEmployeePage}
        acceptedRoles={[UserRoleEnum.OWNER, UserRoleEnum.ADMINISTRATOR]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.PointEmployeeSchedulesLink,
    element: (
      <RoleGuard
        Component={PointEmployeeSchedulesPage}
        acceptedRoles={[
          UserRoleEnum.OWNER,
          UserRoleEnum.ADMINISTRATOR,
          UserRoleEnum.MANAGER,
        ]}
      ></RoleGuard>
    ),
  },
  {
    path: AppLinks.EmailConfirmationLink,
    element: <EmailConfirmationPage />,
  },
  {
    path: AppLinks.PasswordChangeLink,
    element: <PasswordChangePage />,
  },
  {
    path: AppLinks.CustomerCreateBookingLink,
    element: <CustomerCreateBookingPage />,
  },
  {
    path: AppLinks.DayCalendarLink,
    element: (
      <RoleGuard
        Component={DayCalendarPage}
        acceptedRoles={[
          UserRoleEnum.OWNER,
          UserRoleEnum.ADMINISTRATOR,
          UserRoleEnum.MANAGER,
          UserRoleEnum.EMPLOYEE,
        ]}
      />
    ),
  },
  {
    path: AppLinks.PrivacyPolicyLink,
    element: <PrivacyPolicyPage />,
  },
  {
    path: AppLinks.TermsOfServiceLink,
    element: <TermsOfServicePage />,
  },
  {
    path: AppLinks.CookiePolicyLink,
    element: <CookiePolicyPage />,
  },
  {
    path: AppLinks.LicenseAgreementLink,
    element: <LicenseAgreementPage />,
  },
]);
